<p class="general-logout-modal__message">{{ 'generalLogout.message' | translate }}</p>

<div class="general-logout-modal__actions">
    <p-button rounded [label]="'generalLogout.continueButton' | translate" severity="primary" (onClick)="continue()" />
</div>
